"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgClipboard(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.937 0c1.096 0 2.012.753 2.303 1.775.788.17 1.469.64 1.928 1.288h3.938c.388 0 .709.289.76.663l.006.104v19.404a.766.766 0 01-.662.759l-.104.007H3.766a.766.766 0 01-.759-.662L3 23.234V3.83c0-.388.288-.708.662-.76l.104-.006 3.94-.001a3.209 3.209 0 011.928-1.289C9.923.753 10.84 0 11.937 0zm4.846 4.833l.005.188v.851a.766.766 0 01-.662.76l-.104.006h-8.17a.766.766 0 01-.76-.662l-.006-.104v-.851c0-.145.008-.287.026-.426h-2.58v17.873H19.34V4.596l-2.579-.001c.01.078.017.158.022.238zm-4.846-3.301c-.437 0-.807.351-.862.818l-.007.118a.766.766 0 01-.662.76l-.103.006c-.875 0-1.605.712-1.68 1.632l-.006.155v.085h6.638v-.085c0-.94-.684-1.703-1.541-1.78l-.144-.007a.766.766 0 01-.766-.766c0-.524-.396-.936-.867-.936z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgClipboard;
exports.default = _default;